export enum BookingEventSetupWizardStep {
  Details,
  Dates,
  RegistrationForm,
  Settings
}
